import device from "current-device";
import fullpage from "fullpage.js/dist/fullpage.extensions.min";
import "fullpage.js/vendors/scrolloverflow.min";
//import "slick-carousel/slick/slick.min.js";

export default {
    init() {
        // JavaScript to be fired on all pages

        $(document).ready(function () {
            

            //init slider
            $('.slick__wrapper').slick( {'dots': true, 'arrows': false} );          

            
            //dots color like text color
            $('.slick__wrapper').on('afterChange', function(event, slick, currentSlide, nextSlide){
                
                var activeSlide = $(this).find('.slick-active .case-text');
                var colorClass = activeSlide.attr('class').replace('case-text', '');

                $(this).parent().removeClass('dark-text light-text').addClass(colorClass);
            });

            //open popup and go to slide №*
             $('.cases-new__item').click(function(){
                
                $('.home').addClass('noscroll');

                var position = $(this).attr('data-position');
                
                $('.slick__wrapper').slick('slickGoTo', position, true);

                $(this).parents('.section').find('.cases-popup').addClass('active__popup');
            });

            //close popup
            $('.close-popup').click(function(){
                $(this).parent().removeClass('active__popup');
                $('.home').removeClass('noscroll');
            })

            //make works section to slider for tablets ahd phones 
            if ( !device.desktop() ) {
                $('.cases-new__wrapper .grid').slick( {'dots': true, 'arrows': false});
            }
            
            //

            const html = $('html');

            $('.mobile-menu-btn').on('click', function () {
                html.toggleClass('menu-open');
            });

            $(window).scroll(function () {
                const fixedHeader = $('.header');
                const scroll = $(window).scrollTop();


                if ($(window).width() > 600) {
                    if (scroll >= 100) fixedHeader.addClass('fixed');
                    else fixedHeader.removeClass('fixed');

                } else {
                    if (scroll >= 10) fixedHeader.addClass('fixed');
                    else fixedHeader.removeClass('fixed');
                }

                if (html.hasClass('menu-open')) {
                    fixedHeader.removeClass('fixed');
                }

            });

            $(".menu-item a").on("click", function (event) {
                const hash = event.target.hash;
                if (hash) {
                    event.preventDefault();
                    const tag = $(hash);
                    if ($(hash).length) {
                        const offset = $(window).width() > 767 ? tag.offset().top : tag.offset().top - 55;
                        $('html, body').stop().animate({scrollTop: offset}, 500);
                    }
                }

                if (html.hasClass('menu-open')) {
                    html.toggleClass('menu-open');
                    $('.header').removeClass('fixed');
                }

            });
        });

        let anchors = [];
        $('.main .section').each(function() {
            anchors.push($( this ).attr('data-anchor'));
        });

        if (device.desktop()) {
            var screenSlide = new fullpage('.main', {
                
                licenseKey: 'key',
                navigation: false,
                anchors: anchors,
                lockAnchors: true,
                fixedElements: '.header .wrap-footer',
                scrollBar: true,
                scrollOverflowReset: true,
                resetSliders: true,
                loopBottom: false,
                loopTop: false,

                //if popup is active no scrolling and list slides
                onLeave: function(index, nextIndex, direction){
                    
                    if($('.cases-popup').hasClass('active__popup')){

                        if (direction == 'up') {
                            $('.slick__wrapper').slick('slickPrev');
                        }

                        if (direction == 'down') {
                            $('.slick__wrapper').slick('slickNext');
                        }                        
                        return false;                  
                    }
                }
            });
        } else {
            screenSlide.destroy('all')
        }
        document.addEventListener( 'wpcf7mailsent', function( event ) {            

       
          /*eslint-disable */
           dataLayer.push({'event': 'send-form'});     
          /*eslint-enable */
            
        }, false );




    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
